import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import HeaderUI from "../components/HeaderUI";
import Cookies from 'js-cookie'
import { getUser } from "../../auth";

const URL = process.env.REACT_APP_API_URL;

export default function Header() {
  const location = useLocation();
  const navigate = useNavigate();
  const [empresa, setEmpresa] = useState(null);
  
  useEffect(() => {
    const fetchEmpresa = async () => {
      try {
        const user = getUser();
        const response = await fetch(`${URL}/api/empresas/${user.empresa_id}`);
        if (response.ok) {
          const data = await response.json();
          setEmpresa(data);
        } else {
          console.error("Error al obtener la empresa");
        }
      } catch (error) {
        console.error("Error de red al obtener la empresa", error);
      }
    };

    fetchEmpresa();
  }, []);

  const pageTitles = {
    "/": "PRINCIPAL",
    "/ventas": "VENTAS",
    "/actividad": "ACTIVIDAD",
    "/inventario": empresa?.rubro === "Servicios" ? "MIS SERVICIOS" : "INVENTARIO",
    "/inventario/stock": "STOCK",
    "/datos": "DATOS",
  };

  const handleLogout = () => {
    Cookies.remove('user');
    navigate('/');
    window.location.reload();
  }

  return (
    <HeaderUI
      title={pageTitles[location.pathname] || "Página no encontrada"}
      onLogout={handleLogout}
    />
  );
}